module.exports = __webpack_public_path__ + "assets/img/hot-active.e911b33f.png";